/** 会话列表未读红点样式 */
export const MessageUnreadBadgeConfig = {
  /** 红点直径（px） */
  diameter: 16,
  /** 水平偏移，向右为正（px） */
  offsetX: -2,
  /** 垂直偏移，向下为正（px） */
  offsetY: 4,
  /** 数字字号（px） */
  fontSize: 12,
} as const;
